import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { InteractionType } from "@enums/interactionType.enum";
import { GetPropertiesFromEnum } from "@helpers/getPropertiesFromEnum";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { CrmContact } from "@interfaces/models/crmContact.interface";
import { CrmInteraction } from "@interfaces/models/crmInteraction.interface";
import { UserProfile } from "@interfaces/userProfile.interface";
import { AuthService } from "@services/auth.service";
import { CrmContactService } from "@services/crmContact.service";
import { CrmInteractionService } from "@services/crmInteraction.service";
import { ToastService } from "angular-toastify";

@Component({
	moduleId: module.id,
	selector: "crm-contacts-id",
	styleUrls: ["crmContacts-id.css"],
	templateUrl: "crmContacts-id.html"
})
export class CrmContactIdAdminComponent {
	headerPrimaryButtons: AdminHeaderButton[] = [];
	interactionTypes: any[] = [];
	interactions: CrmInteraction[] = [];
	item: CrmContact = new CrmContact();
	itemId = 0;
	itemType = "CRM Contact";
	popupAddButtonOptions: any;
	popupCloseButtonOptions: any = { onClick: () => this.closePopup(), text: "Close" };
	popupInteraction: CrmInteraction = new CrmInteraction();
	popupVisible = false;
	readOnly = true;
	returnUrl: string = location.href.split("/")[3] + "/" + location.href.split("/")[4];
	title: string = "View " + this.itemType;
	userProfile: UserProfile = new UserProfile();

	constructor(private router: Router, private toastService: ToastService, private route: ActivatedRoute, private itemService: CrmContactService, private crmInteractionService: CrmInteractionService, private authService: AuthService) {
		this.interactionTypes = GetPropertiesFromEnum(InteractionType);
		this.buildButtons("view");
		this.getUserProfile();
		this.route.params.subscribe((params) => {
			if (params.id !== "create") {
				if (params.id.split("_").length > 1) {
					this.itemId = params.id.split("_")[0];
					this.getItem(this.itemId);
					this.edit();
				} else {
					this.itemId = params.id;
					this.getItem(params.id);
				}
			} else {
				this.create();
			}
		});
	}

	addNewInteractionPopup() {
		this.popupVisible = true;
		this.popupInteraction = new CrmInteraction();
		this.popupInteraction.interactionDate = new Date();
		this.popupAddButtonOptions = { onClick: () => this.saveInteraction(), text: "Add Interaction" };
	}

	buildButtons(mode: string) {
		if (mode === "edit") {
			this.headerPrimaryButtons = [
				{ method: "updateItem", text: "Save Changes" },
				{ method: "cancelEditing", text: "View Mode" },
				{ method: "close", text: "Close" }
			];
		} else if (mode === "create") {
			this.headerPrimaryButtons = [
				{ method: "createItem", text: "Save New Contact" },
				{ method: "close", text: "Close" }
			];
		} else {
			this.headerPrimaryButtons = [
				{ method: "edit", text: "Edit" },
				{ method: "close", text: "Close" }
			];
		}
	}

	cancelEditing() {
		this.readOnly = true;
		this.buildButtons("view");
		this.title = "View " + this.itemType;
		this.getItem(this.itemId);
	}

	close() { this.router.navigate([this.returnUrl]); }

	closePopup() { this.popupVisible = false; }

	create() {
		this.readOnly = false;
		this.title = "New " + this.itemType;
		this.buildButtons("create");
	}

	createItem() {
		this.itemService.createSingle(this.item).subscribe(
			(res: any) => { this.toastService.success("Contact created!"); this.router.navigate([`${this.returnUrl}/${res.response.id}`]); },
			(err) => { console.log(err); this.toastService.error("Something Went Wrong!"); }
		);
	}

	edit() {
		this.readOnly = false;
		this.title = "Edit " + this.itemType;
		this.buildButtons("edit");
	}

	getInteractions(contactId: any) {
		this.crmInteractionService.getByContactId(contactId).subscribe(
			(res: any) => { this.interactions = res.response || []; },
			(err) => { console.log(err); }
		);
	}

	getItem(id: any) {
		this.itemService.getSingleById(id).subscribe(
			(res: any) => { this.item = res.response; this.getInteractions(id); },
			(err) => { console.log(err); this.toastService.error("Something Went Wrong!"); }
		);
	}

	getUserProfile() {
		this.authService.getCurrentUserProfile().subscribe(
			(res: any) => { this.userProfile = res.response; },
			(err) => { console.log(err); }
		);
	}

	headerButtonClick(method: any) {
		// @ts-ignore
		if (this[method]) this[method]();
	}

	saveInteraction() {
		this.popupInteraction.crmContactId = this.item.id;
		this.popupInteraction.instigatorId = this.userProfile.id;
		this.crmInteractionService.createSingle(this.popupInteraction).subscribe(
			() => { this.closePopup(); this.getInteractions(this.itemId); this.toastService.success("Interaction added!"); },
			(err) => { console.log(err); this.toastService.error("Something Went Wrong!"); }
		);
	}

	updateItem() {
		this.itemService.updateSingleById(this.item.id, this.item).subscribe(
			() => { this.toastService.success("Contact updated!"); this.cancelEditing(); },
			(err) => { console.log(err); this.toastService.error("Something Went Wrong!"); }
		);
	}
}
